import { CustomFieldValue } from 'app/core/user/models/custom-field-value.model';
import { ProfileFilterValue } from 'app/core/user/models/profile-filter-value.model';

import { ErgoTeamMemberInterface } from './ergo-team-member.model';

export interface UserInterface {
  customFieldValues?: CustomFieldValue[];
  displayName?: string;
  firstName?: string;
  forcePassword?:boolean;
  fullDataAccess?: boolean;
  gender?: number;
  isAdminUser?: boolean;
  hasFullDataAccess?: boolean;
  lastName?: string;
  primaryEmail?: string;
  primaryPhone?: string;
  profileFilterValues?: ProfileFilterValue[];
  roleId?: number;
  roleLabel?: string;
  secondaryEmail?: string;
  userDisabled?: boolean;
  id?: number;
  userName?: string;
  tcAccept?: boolean;
  ssoAccessOnly?: boolean;
  ergoTeam?: ErgoTeamMemberInterface[];
  sessionTimeOut?:number;
  readonly fullName?: () => string;
}

export class User implements UserInterface {
  public customFieldValues?: CustomFieldValue[];
  public displayName?: string;
  public firstName?: string;
  public forcePassword?:boolean;
  public fullDataAccess?: boolean;
  public gender?: number;
  public isAdminUser?: boolean;
  public hasFullDataAccess?: boolean;
  public lastName?: string;
  public primaryEmail?: string;
  public primaryPhone?: string;
  public profileFilterValues?: ProfileFilterValue[];
  public roleId?: number;
  public roleLabel?: string;
  public secondaryEmail?: string;
  public userDisabled?: boolean;
  public id?: number;
  public userName?: string;
  public tcAccept?: boolean;
  public ssoAccessOnly?: boolean;
  public sessionTimeOut?:number;
  public ergoTeam?: ErgoTeamMemberInterface[];

  constructor({
    customFieldValues = undefined,
    firstName = undefined,
    forcePassword= undefined,
    fullDataAccess = undefined,
    gender = undefined,
    isAdminUser = undefined,
    hasFullDataAccess = undefined,
    lastName = undefined,
    primaryEmail = undefined,
    primaryPhone = undefined,
    profileFilterValues = undefined,
    roleId = undefined,
    roleLabel = undefined,
    secondaryEmail = undefined,
    userDisabled = undefined,
    id = undefined,
    userName = undefined,
    tcAccept = undefined,
    ssoAccessOnly = undefined,
    ergoTeam = undefined,
    sessionTimeOut= 0,
    }: UserInterface) {
    this.customFieldValues = customFieldValues;
    this.displayName = `${firstName}${lastName ? ` ${lastName}` : ''}`;
    this.firstName = firstName;
    this.forcePassword = forcePassword;
    this.fullDataAccess = fullDataAccess;
    this.gender = gender;
    this.isAdminUser = isAdminUser;
    this.hasFullDataAccess = hasFullDataAccess;
    this.lastName = lastName;
    this.primaryEmail = primaryEmail;
    this.primaryPhone = primaryPhone;
    this.profileFilterValues = profileFilterValues;
    this.roleId = roleId;
    this.roleLabel = roleLabel;
    this.secondaryEmail = secondaryEmail;
    this.userDisabled = userDisabled;
    this.id = id;
    this.userName = userName;
    this.tcAccept = tcAccept;
    this.ssoAccessOnly = ssoAccessOnly;
    this.ergoTeam = ergoTeam;
    this.sessionTimeOut= sessionTimeOut;
  }

  public fullName?(): string {
    return `${this.firstName}${this.lastName ? ` ${this.lastName}` : ''}`;
  }
}
